/*
 * Copyright © 2019 Franck Borel, Martin Helfer, Sebastian Schüpbach
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

/**
 * Displays collapsible container.
 */
@Component({
  selector: 'app-expandable',
  template: `
    <ng-container *ngFor="let data of currentList()">
      <li>
        <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="data"></ng-container>
      </li>
    </ng-container>
    <li class="expandable__more" *ngIf="canShowMore()">
      <button type="button" class="expandable__title link-black" (mousedown)="expand($event)">
        {{'expandable.expand' | translate}}
      </button>
    </li>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableComponent {
  @Input() itemTemplate;
  @Input() itemsPerExpansion: number;
  @Input() items: [];

  protected at = 0;

  public expand(event) {
    event.preventDefault();
    this.at = this.at + this.itemsPerExpansion;
  }

  currentList() {
    return this.items.slice(0, Math.min(this.items.length, this.at + this.itemsPerExpansion));
  }

  canShowMore() {
    return (this.at + this.itemsPerExpansion) < this.items.length;
  }
}
